import CryptoJS from 'crypto-js';

export const dtext = (text) => {
    const bytes  = CryptoJS.AES.decrypt(text, 'G6uBhAcWFEre7S7VRqyH6');
    const otext = bytes.toString(CryptoJS.enc.Utf8);
    return otext;
};

export const etext = (text) => {
    const e = CryptoJS.AES.encrypt(text, 'G6uBhAcWFEre7S7VRqyH6').toString();
    return e;
};